<template>
  <div class="transactions-table__wrapper" :style="cssVariables">
    <div class="transactions-table">
      <slot name="tableHeader"></slot>
      <div class="transactions-table__body">
        <slot name="transactionItems" v-if="!isTransactionsLoading"></slot>
        <div class="transactions-table__body-loading" v-else>
          <loader></loader>
        </div>
      </div>
    </div>
    <slot
      name="tablePagination"
      v-if="hasPagination && !isTransactionsLoading"
    ></slot>
  </div>
</template>

<script>
import TransactionsTableHeader from '@vue-app/components/company/transactions/table/TransactionsTableHeader.vue'
import Loader from '@vue-app/components/base/Loader.vue'

export default {
  name: 'TransactionsTable',
  components: {
    Loader,
    TransactionsTableHeader,
  },
  props: {
    gridTemplateColumns: {
      type: String,
      default: '',
    },
    columnGap: {
      type: String,
      default: '10px',
    },
    hasPagination: {
      type: Boolean,
      default: true,
    },
    isTransactionsLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cssVariables() {
      return {
        '--grid-template-columns': this.gridTemplateColumns,
        '--column-gap': this.columnGap,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.transactions-table) {
  .transactions-table__header {
    grid-template-columns: var(--grid-template-columns);
    column-gap: var(--column-gap);
  }

  .transactions-table__body {
    .transactions-bills-to-card-table-item {
      .transaction-table-item__short-info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 20px;

        .transaction-table-item__col {
          width: max-content;
          flex: 1;
        }

        .transaction-table-item__amount,
        .transaction-table-item__status {
          justify-content: center;
        }

        .transaction-table-item__account-number {
          justify-content: center;
        }

        .transaction-table-item__phone {
          word-break: break-all;
        }

        .transaction-table-item__actions {
          justify-content: flex-end;
        }

        .transaction-table-item__open-btn {
          right: 90px;
        }
      }
    }
    &-loading {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px;
    }
  }

  .transactions-table-pagination {
    margin-top: 35px;
  }

  .transaction-table-item {
    &__short-info {
      grid-template-columns: var(--grid-template-columns);
      column-gap: var(--column-gap);
    }
  }
}
</style>
